// extracted by mini-css-extract-plugin
export default {"container":"_23mfrZCZQVnPsvN34XSj5Z","info":"_21wIMZUUWJALQZ0ZPZUtjn","accordionState":"_6J06jrfUfRGlGccsQB4vFY"};